import type { MatchedAttribute } from "./types";

const FIELD_LABEL_MAP = [
  { field: "materials", label: "Material" },
  { field: "benefits", label: "Benefit" },
  { field: "lamination", label: "Lamination" },
  { field: "stickerType", label: "Sticker Type" },
  { field: "productType", label: "Product" },
] as const;

const MARK_TAG_PATTERN = /<\/?mark>/g;
const MARK_START_TAG = "<mark>";
const MAX_DISPLAYED_ATTRIBUTES = 2;

function extractObjectSnippet(value: unknown): string | null {
  if (value && typeof value === "object" && "snippet" in value) {
    const snippet = value.snippet;
    if (typeof snippet === "string") return snippet;
  }
  return null;
}

function extractArraySnippet(values: unknown[]): string | null {
  let firstSnippet: string | null = null;
  for (const entry of values) {
    const snippet = extractSnippet(entry);
    if (!snippet) continue;
    if (snippet.includes(MARK_START_TAG)) return snippet;
    firstSnippet ??= snippet;
  }
  return firstSnippet;
}

function extractSnippet(value: unknown): string | null {
  if (Array.isArray(value)) return extractArraySnippet(value);
  return extractObjectSnippet(value);
}

export function formatMatchedAttributes(highlight: Record<string, unknown>): MatchedAttribute[] {
  const matched: MatchedAttribute[] = [];
  for (const { field, label } of FIELD_LABEL_MAP) {
    const snippet = extractSnippet(highlight[field]);
    if (!snippet) continue;
    matched.push({ label, value: snippet.replace(MARK_TAG_PATTERN, "") });
    if (matched.length >= MAX_DISPLAYED_ATTRIBUTES) break;
  }
  return matched;
}
